module.exports = __webpack_public_path__ + "img/s1-img1.730dce9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lifeHome/s1-img1.jpg
// module id = 401
// module chunks = 0